<template>
<el-table :data="list" style="width: 100%">
  <el-table-column label="测点编码" width="100">
    <template slot-scope="{}">
      {{stationcode}}
    </template>
  </el-table-column>
  <el-table-column label="测点名称">
    <template slot-scope="{}">
      {{stationname}}
    </template>
  </el-table-column>
  <el-table-column label="缴费单位" v-if="payunit">
    <template slot-scope="{}">
      {{payunit}}
    </template>
  </el-table-column>
  <el-table-column prop="stime" label="开始时间" width="100">
    <template slot-scope="scope">
      {{scope.row.stime.split(' ')[0]}}
    </template>
  </el-table-column>
  <el-table-column prop="etime" label="结束时间" width="100">
    <template slot-scope="scope">
      {{scope.row.etime.split(' ')[0]}}
    </template>
  </el-table-column>
  <el-table-column prop="quantity" label="用水量(顿)" width="100"></el-table-column>
  <el-table-column prop="price" label="费用"></el-table-column>
</el-table>
</template>

<script>
export default {
  props: {
    stationcode: null,
    stationname: null,
    payunit: null,
    list: Array
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/components/payment-detail.vue